import { SingleUser, DossierGroupResponse } from '../api/types';
import { User } from './User';

export enum EDossierGroupType {
  oneToAdmin = 'oneToAdmin',
  oneClientToCaregiver = 'oneClientToCaregiver',
  oneResponsiblePartyToCaregiver = 'oneResponsiblePartyToCaregiver',
  oneRelationToCaregiver = 'oneRelationToCaregiver',
  groupResponsiblePartiesAndCaregiver = 'groupResponsiblePartiesAndCaregiver',
  custom = 'custom',
}

export interface DossierGroupInterface {
  groupId: number;
  name: string;
  type: EDossierGroupType;
  users: SingleUser[];
}

export class DossierGroup implements DossierGroupInterface {
  groupId: number;
  name: string;
  type: EDossierGroupType;
  users: User[];

  constructor({ groupId, name, type, users }: DossierGroupInterface) {
    this.groupId = groupId;
    this.name = name;
    this.type = type;
    this.users = users.map(user => new User(user));
  }

  static fromRequest(response: DossierGroupResponse[]): DossierGroup[] {
    return response.map(dossierGroup => (
      new DossierGroup({
        groupId: dossierGroup.id,
        name: dossierGroup.name,
        type: dossierGroup.type,
        users: dossierGroup.users,
      })
    ));
  }

  shouldDisplayChat(): boolean {
    if (this.type === EDossierGroupType.groupResponsiblePartiesAndCaregiver) {
      return this.users.length > 2;
    }
    return this.users.length > 1;
  }

  match(member: DossierGroup): boolean {
    return member.groupId === this.groupId;
  }
}
